export default function Wave() {
  return (
    <svg width="100%" height="full" viewBox="0 0 1440 163" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 0H1440V129.5C1440 129.5 1340 74 1261.5 74C1189.25 74 1149.22 151.797 1077.5 160.5C927.07 178.754 882.011 76.6222 730.5 74C623.061 72.1405 568.452 130.274 461 129.5C357.179 128.752 304.643 67.8674 201 74C119.709 78.81 0 129.5 0 129.5V0Z"
            fill="#D8C4A5" />
    </svg>
)}